const MuiTextField = () => ({
  defaultProps: {
    variant: 'outlined' as const
  }
});

export default MuiTextField;
